<div class="modal-container">
  <button
    id="modalAgregarEntidadSegundaInstanciaButton"
    #modalAgregarEntidadSegundaInstanciaButton
    data-bs-toggle="modal"
    data-bs-target="#modalAgregarEntidadSegundaInstancia"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAgregarEntidadSegundaInstancia"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header modal-header-govco modal-header-alerts-govco">
          <button
            type="button"
            class="btn-close mt-1"
            aria-label="Close"
            (click)="restablecerForm()"></button>
        </div>
        <div class="modal-body modal-body-govco">
          <app-form
            [title]="'modal-segunda-instancia.titulo' | translate"
            [fields]="fieldsAgregarEntidadSegundaInstancia"
            [sumbitButtonText]="'modal-segunda-instancia.guardar' | translate"
            (changeAction)="onChangeForm($event)"
            (submitAction)="onSubmitCrearEntidadSegundaInstancia($event)"></app-form>
        </div>
      </div>
    </div>
  </div>
</div>
